import { Entity, EntityMeta } from '@backstage/catalog-model';
import { generateAjvJsonSchemaValidator } from '../utils';
import schema from '../schema/SystemPrototypeType.v2alpha1.schema.json';

declare interface SystemPrototypeTypeEntity extends Entity {
  apiVersion: 'witboost.com/v2';
  kind: 'SystemPrototypeType';
  metadata: {
    name: string;
    displayName?: string;
  } & EntityMeta;
  spec: {
    evolvesInto: string;
    template?: string;
  };
}

export type { SystemPrototypeTypeEntity as SystemPrototypeType };

export type HeadlessSystemPrototype = SystemPrototypeTypeEntity & ProjectType;

export const systemPrototypeTypeEntityV1alpha1Validator =
  generateAjvJsonSchemaValidator(schema);

export function isSystemPrototype(
  entity: Entity,
): entity is SystemPrototypeTypeEntity {
  return (
    entity.apiVersion === 'witboost.com/v2' && entity.kind === 'SystemPrototype'
  );
}

export function isSystemPrototypeType(
  entity: Entity,
): entity is SystemPrototypeTypeEntity {
  return (
    entity.apiVersion === 'witboost.com/v2' &&
    entity.kind === 'SystemPrototypeType'
  );
}
